import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { adminApi } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("lexhab_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      localStorage.setItem("lexhab_user", JSON.stringify(user));
    } else {
      localStorage.removeItem("lexhab_user");
    }
  }, [user]);

  const login = useCallback(async (email, password) => {
    setLoading(true);
    try {
      const { data } = await adminApi.login(email, password);
      localStorage.setItem("lexhab_token", data.access_token);
      // Fetch /me to get the full profile + permissions
      let profile = { email: data.email, full_name: data.full_name, role: data.role };
      try {
        const { data: me } = await adminApi.me();
        profile = { ...profile, ...me };
      } catch (_) {}
      setUser(profile);
      return profile;
    } finally {
      setLoading(false);
    }
  }, []);

  const refresh = useCallback(async () => {
    try {
      const { data } = await adminApi.me();
      setUser((prev) => ({ ...(prev || {}), ...data }));
      return data;
    } catch (e) {
      return null;
    }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("lexhab_token");
    localStorage.removeItem("lexhab_user");
    setUser(null);
  }, []);

  const can = useCallback(
    (perm) => {
      if (!user) return false;
      const perms = user.permissions || [];
      return perms.includes(perm);
    },
    [user]
  );

  return (
    <AuthContext.Provider value={{ user, login, logout, refresh, can, loading, isAuthed: !!user }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
